import React from "react";
import { useApiData } from "../hooks/useFetch.js";
import { api } from "../api/api.js";
import StateGuard from "./StateGuard.jsx";
import PhenoChart from "../charts/PhenoChart.jsx";
import PhenoGanttChart from "../charts/PhenoGanttChart.jsx";

export default function PhenologieTab({ baseParams, culture, libelle }) {
  const { data, loading, error } = useApiData(api.getPheno, baseParams, {
    // gridno a disparu (la localisation est résolue côté API depuis
    // idExploitation) et idProdu s'appelle désormais idProduction : l'ancienne
    // condition était toujours vraie, donc l'appel n'était jamais lancé.
    skip: !baseParams.idExploitation || !baseParams.idProduction,
  });

  return (
    <StateGuard
      loading={loading}
      error={error}
      empty={!data || data.length === 0}
      emptyMessage="Pas de données phéno pour cette région / culture."
    >
      <div className="oad-panel">
        <h3>Progression phénologique (GDD)</h3>
        {data && <PhenoChart data={data} />}
      </div>
      <div className="oad-panel">
        <h3>Durée des stades phénologiques</h3>
        {data && <PhenoGanttChart data={data} />}
      </div>
    </StateGuard>
  );
}
